<div class="container" kendoTooltip tooltipClass="tooltip-adjust-right" [ngClass]="{'isSelected': isSelected}">
    <div class="one-line-detail one-line-height-18 meatball-parent">
        <div class="entity-area text-ellipsis" *ngIf="primaryEntityName">
            <span class="one-entity text-ellipsis">{{primaryEntityName}}</span>
        </div>
        <div class="card-meatball" (click)="onMeatBall($event)">
            <smart-icon class="light" name="meatball"></smart-icon>
        </div>
    </div>
    <div class="one-line-detail">
        <div class="primary-name-area" [title]="getInstanceName()">
            {{getInstanceName()}}
        </div>
    </div>
    <div class="field-area" *ngIf="fields.length">
        <div class="one-field one-line-height-15 text-font-12" *ngFor="let item of fields"
            attr.tid="{{item.fieldDefinition.name}}" [ngSwitch]="item.fieldDefinition.type"
            [ngClass]="{'multi-line-field-value': item.fieldDefinition.type==='textArea'}">
            <div class="field-name-area">
                <div class="field-name text-ellipsis" [title]="item.fieldDefinition.name">{{item.fieldDefinition.name}}
                </div>
                <div class="field-name-colon">:</div>
            </div>
            <div class="field-value text-ellipsis" *ngSwitchCase="'entity'"
                [title]="getDisplayValueForEntities(item.value)">
                <div *ngIf="item.value && isEntityArray(item.value)" class="overflow-ellipsis-block">
                    <ng-container *ngFor="let linkItem of item.value;let i= index">
                        <a href="{{getEntityRelativeLink(linkItem)}}" target='_blank'>{{linkItem.shortName}}{{i+1
                            === item.value.length?'':';'}}</a>&nbsp;
                    </ng-container>
                </div>
                <div *ngIf="item.value && !isEntityArray(item.value)" class="overflow-ellipsis-block">
                    <a href="{{getEntityRelativeLink(item.value)}}" target='_blank'>{{item.value.shortName}}</a>
                </div>
            </div>
            <div class="field-value text-ellipsis" *ngSwitchCase="'user'"
                [title]="getDisplayValueForEntities(item.value)">
                <div *ngIf="item.value && isEntityArray(item.value)" class="overflow-ellipsis-block">
                    <ng-container *ngFor="let linkItem of item.value;let i= index">
                        <a href="{{getEntityRelativeLink(linkItem)}}" target='_blank'>{{linkItem.shortName}}{{i+1
                            === item.value.length?'':';'}}</a>&nbsp;
                    </ng-container>
                </div>
                <div *ngIf="item.value && !isEntityArray(item.value)" class="overflow-ellipsis-block">
                    <a href="{{getEntityRelativeLink(item.value)}}" target='_blank'>{{item.value.shortName}}</a>
                </div>
            </div>
            <kendo-numerictextbox class="field-value" *ngSwitchCase="'number'" [value]="item.value"
                [format]="getFormatForNumber(item)" [spinners]="false" [readonly]="true">
            </kendo-numerictextbox>
            <div class="field-value text-ellipsis" *ngSwitchCase="'date'" [title]="item.value|date:'dd MMM yyyy'">
                {{item.value|date:'dd MMM yyyy'}}
            </div>
            <div class="field-value text-ellipsis" *ngSwitchDefault [title]="item.value">
                {{item.value}}
            </div>
            <div class="multi-line-field-value" *ngSwitchCase="'textArea'" [title]="item.value">
                <span>{{item.value}}</span>
            </div>
            <tam-file-info class="field-value" *ngSwitchCase="'file'" [config]="item.value" [isDefaultToPreview]="true">
            </tam-file-info>
            <div class="field-value text-ellipsis" *ngSwitchCase="'checkList'"
                [title]="getCheckListFieldInfo(item, checkLists)">
                {{getCheckListFieldInfo(item, checkLists)}}
            </div>
        </div>
    </div>
    <div class="one-line-detail one-line-height-18">
        <div class="progress-bar-container">
            <div class="progress-bar" *ngFor="let item of [].constructor(totalCountByInstance);index as i"
                [style.width]="(100/totalCountByInstance)+'%'">
                <div class="bar-tail">
                    <div class="bar-tail-up"
                        [ngClass]="{'todo-top-color':instance.status==='inprocess'&&i>=finishedTaskCount,'undo-top-color':instance.status!=='inprocess'&&i>=finishedTaskCount}">
                    </div>
                    <div class="bar-tail-bottom"
                        [ngClass]="{'todo-bottom-color':instance.status==='inprocess'&&i>=finishedTaskCount,'undo-bottom-color':instance.status!=='inprocess'&&i>=finishedTaskCount}">
                    </div>
                </div>
                <div class="bar-body"
                    [ngClass]="{'todo-color':instance.status==='inprocess'&&i>=finishedTaskCount,'undo-color':instance.status!=='inprocess'&&i>=finishedTaskCount}">
                </div>
                <div class="bar-head">
                    <div class="bar-head-up"
                        [ngClass]="{'todo-bottom-color':instance.status==='inprocess'&&i>=finishedTaskCount,'undo-bottom-color':instance.status!=='inprocess'&&i>=finishedTaskCount}">
                    </div>
                    <div class="bar-head-bottom"
                        [ngClass]="{'todo-top-color':instance.status==='inprocess'&&i>=finishedTaskCount,'undo-top-color':instance.status!=='inprocess'&&i>=finishedTaskCount}">
                    </div>
                </div>
            </div>
        </div>
        <div class="progress-number">{{finishedTaskCount}}/{{totalCountByInstance}}
        </div>
    </div>
    <div class="one-line-detail one-line-height-15" *ngIf="dueDateOrEndDate">
        <div class="card-extra">
        </div>
        <div class="card-date-area" *ngIf="dueDateOrEndDate">
            <smart-icon name="timer"></smart-icon>
            <span class="text-12 card-date">{{dueDateOrEndDate|date:'dd MMM yyyy'}}</span>
        </div>
    </div>
</div>